import { SexFlug } from "../../../assets/data/Constants";
import { TkGetCode } from "../../../utils/TkGetCode";

function funBodyList(res: any) {
  const bodyList: any[] = [];
  // eslint-dTkble-next-line array-callback-return
  res.facilityList.forEach((item: any) => {
    item.staffList.forEach((itemStaffList: any) => {
      const data = [
        {
          id: itemStaffList.staffNo,
        },
        {
          children: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
        },
        {
          children: (itemStaffList.staffNo ?? "") + ":" + (itemStaffList.staffNameKanji ?? ""),
        },
        {
          children: itemStaffList.birthday,
          align: "center",
        },
        {
          children: TkGetCode(SexFlug, itemStaffList.sex),
          align: "center",
        },
        {
          children: itemStaffList.joinDate,
          align: "center",
        },
      ];
      bodyList.push(data);
    });
  });

  return bodyList;
}

export { funBodyList };
